<div class="flex-column gap p-2">

    <div class="flex gap pt-2">
        <app-date-input class="flex-1" [form]="form" id="dateFrom" [prefix]="prefix"></app-date-input>
        <app-date-input class="flex-1" [form]="form" id="dateTo" [prefix]="prefix"></app-date-input>
    </div>

    <app-error-float-message [(visible)]="existsVoucher">
        {{ 'voucher.messages.datesOverlay' | translate:{ voucher: existingVoucher | formatVoucher } }}
    </app-error-float-message>
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons [primaryButtonDisability]="existsVoucher" (primaryClickEvent)="save($event)"
        (secondaryClickEvent)="dialogRef.close()"></app-action-buttons>
</div>
